import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

export default function OpenClose({ closed }) {
  return <div className={`${styles.close} ${closed && styles.closed}`} />;
}

OpenClose.propTypes = {
  closed: PropTypes.bool.isRequired
};
